import { NonIndexRouteObject, RouteObject } from 'react-router';

import { Routes as ModuleRoutes } from '../modules';
import clientActions from '../modules/client/actions';
import dataActions from '../modules/data/actions';
import NotFound from '../pages/NotFound';
import App from './App';

function makePaths(children: RouteObject[]): RouteObject[] {
  return children.map((origin) => {
    const item: any = {};

    if (origin.index) {
      item.index = true;
    } else if (origin.path) {
      item.path = origin.path.replace(/^\//, '');
    }

    Object.keys(origin)
      .filter((key) => !['path', 'children', 'index'].includes(key))
      .forEach((key) => {
        (item as Record<string, unknown>)[key] = (
          origin as Record<string, unknown>
        )[key];
      });

    if (origin.children) {
      item.children = makePaths(origin.children);
    }

    return item;
  });
}

const loader = () => [
  dataActions.Data.prepare(),
  dataActions.Data.loadIfNeeded(),
  clientActions.Client.loadLoginDataIfNeeded(),
  dataActions.Data.loadLangIfNeeded(),
  clientActions.TotalBalance.loadIfNeeded(),
];

const routes: NonIndexRouteObject[] = [
  {
    path: '/',
    Component: App,
    loader,
    children: [
      ...makePaths(ModuleRoutes),
      {
        path: '*',
        Component: NotFound,
      },
    ],
  },
];

export default routes;
